import { EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../../common.service";
import { ApiService } from "../../api.service";
import { CookieService } from "ngx-cookie-service";
var LearningCampIntroductionComponent = (function () {
    function LearningCampIntroductionComponent(route, router, apiService, cookieService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.cookieService = cookieService;
        this.commonService = commonService;
        this.onCloseLearningCampIntroduction = new EventEmitter();
        this.isClosePage = false; //是否关闭页面
        this.isShowCommonBtn = false; //关闭按钮文字判断
        this.assetsRoute = "../../../assets"; //静态资源地址
        this.isShowBottomBtn = false; //是否显示底部按钮
    }
    LearningCampIntroductionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.commonService.getOnceIno(this.onceValue).then(function (result) {
            _this.isShowCommonBtn = result !== 1;
        });
    };
    LearningCampIntroductionComponent.prototype.ngAfterViewInit = function () {
    };
    //关闭学习旅程
    LearningCampIntroductionComponent.prototype.closeLearningCampIntroduction = function () {
        var _this = this;
        this.isClosePage = true;
        this.commonService.setOnceIno(this.onceValue).subscribe(function () {
            setTimeout(function () {
                _this.onCloseLearningCampIntroduction.emit();
            }, 300);
        });
    };
    return LearningCampIntroductionComponent;
}());
export { LearningCampIntroductionComponent };



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-introduction/learning-camp-introduction.component.ts.pre-build-optimizer.js